import type { Account, Person, Transaction } from '@fd/schemas';

/**
 * Who a settlement payment went from and to: "Classic 8168 (K) → Marcin". The other side is the
 * counterpart account when it is in the app, else the household's one other person (the owner,
 * 01.10.2026: „brak … informacji z jakiego konta na które zostało przesłane”).
 */
export function settlementRoute(
  transaction: Pick<Transaction, 'kind' | 'amountMinor' | 'counterpartAccountId'>,
  account: Pick<Account, 'name' | 'owners'> | undefined,
  persons: readonly Pick<Person, 'displayName' | 'archivedAt' | 'id'>[],
  accounts: readonly Pick<Account, 'id' | 'name'>[] = [],
): string | null {
  if (transaction.kind !== 'SETTLEMENT_PAYMENT' || !account) return null;
  const counterpart = transaction.counterpartAccountId ? accounts.find((a) => a.id === transaction.counterpartAccountId)?.name : undefined;
  const others = persons.filter((p) => !p.archivedAt && !account.owners.includes(p.id));
  const other = counterpart ?? (others.length === 1 ? others[0]!.displayName : null);
  if (!other) return account.name;
  return BigInt(transaction.amountMinor) < 0n ? `${account.name} → ${other}` : `${other} → ${account.name}`;
}
